import { NavLink, useNavigate } from "react-router-dom";

const homeIcon = (
  <svg width="23" height="23" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1v-9.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

const pagesIcon = (
  <svg width="23" height="23" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M14 3v5h5M10 13h6M10 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const accountIcon = (
  <svg width="23" height="23" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="8.5" r="3.8" stroke="currentColor" strokeWidth="2" />
    <path d="M5 20c1.4-3.6 4-5.4 7-5.4s5.6 1.8 7 5.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

/** Home, Pages, Account, with the camera one tap away from every one of them. */
export function TabBar() {
  const navigate = useNavigate();
  return (
    <nav className="tabbar" aria-label="Sections">
      <NavLink className="tab" to="/home">
        {homeIcon}
        Home
      </NavLink>
      <NavLink className="tab" to="/pages">
        {pagesIcon}
        Pages
      </NavLink>
      <button
        type="button"
        className="tab-centre press-bounce"
        aria-label="Photograph a page"
        onClick={() => navigate("/capture")}
      >
        <svg width="27" height="27" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 8h3.2l1.6-2.4h6.4L16.8 8H20a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
          <circle cx="12" cy="13.4" r="3.4" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>
      <NavLink className="tab" to="/account">
        {accountIcon}
        Account
      </NavLink>
    </nav>
  );
}
